import {Component, OnInit} from "@angular/core";
import {AlertService, AuthenticationService, ProjectService, UserService} from "../../_services";
import {Router} from "@angular/router";
import {LoginHelper, StringsHelper} from "../../helpers";
import {Project, User} from "../../_models";
import {LogService} from "../../_services/log.service";
import * as moment from 'moment';

@Component({
    standalone: false,
  selector: "log",
  templateUrl: 'log.component.html',
  styleUrls: ['./log.component.scss'],
})
export class LogComponent implements OnInit {
  currentUser: User;
  lastLogin: any;
  lastMonth: any;
  lastYear: any;
  fromType: any;
  from: any;
  to: any;
  data: any[];
  area = 0;
  projectId = 0;
  projects: Project[];
  rowGroupMetadata = {};
  logs: any[];
  users: User[] = [];
  selectedUserIds = [];
  changes = [0];
  userIds = [];

  cols : any[] = [
    {field: 'entityName', header: 'Name'},
    {field: 'fieldName', header: 'Field'},
    {field: 'userName', header: 'User', width: '200px'},
    {field: 'date', header: 'Date', width: '200px'},
    {field: 'valueBefore', header: 'Value Before'},
    {field: 'valueAfter', header: 'Value After'},
  ];

  subcols : any[] = [
    {field: 'fieldTitle', header: 'Field'},
    {field: 'valueBefore', header: 'From'},
    {field: 'valueAfter', header: 'To'},
  ]

  constructor(
    public logService: LogService,
    public projectService: ProjectService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public userService: UserService) {
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.projectService.getAll().subscribe(p => {
      this.projects = p;
    });

    this.userService.getAll().subscribe(u => this.users = u);


    const lastMonthDate = new Date();
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
    this.from = this.lastLogin = this.currentUser.previousLoginTime ? moment(this.currentUser.previousLoginTime) : lastMonthDate;
    this.lastMonth = lastMonthDate;
    const lastYearDate = new Date();
    lastYearDate.setFullYear(lastMonthDate.getFullYear() - 1);
    this.lastYear = lastYearDate.toUTCString();
  }

  updateLogs() {
    this.logService.getAll({
      from: this.from ? moment(this.from).toISOString() : '',
      to: this.to ? moment(this.to).toISOString() : '',
      area: this.area,
      projectId: this.projectId,
      userIds: this.userIds,
      changes: this.changes
    }).subscribe(data => {
        console.log("Updated")
        const logs = data;
        const projectsCache = this.projects;
        this.logs = logs;
        this.splitLogs(logs, projectsCache);
      },

      error => {
        console.log("Failed")
        const errorMessage = 'An error occurred while loading logs.';
        this.alertService.error(errorMessage);
      });


  }

  splitLogs(logs: any[], projectsCache: Project[]) {
    let i;
    const projects = [];
    this.data = [];
    const users = [];
    const controlItems = [];
    const actionPlans = [];
    const others = [];
    const projectMap = {};
    const itprofiles = [];
    console.log("Splitting")

    for (i = 0; i < projectsCache.length; i++) {
      projectMap[projectsCache[i].projectId.toString()] = projectsCache[i];
      (<any>projectsCache[i]).items = [];
    }
    for (i = 0; i < logs.length; i++) {
      try {
        switch (logs[i].entityType) {
          case "Project":
            if (logs[i].entityId && projectMap[logs[i].entityId]) {
              projectMap[logs[i].entityId] = projectMap[logs[i].entityId] || {
                name: 'Project ' + projectMap[logs[i].entityId].name,
                items: []
              };
              this.addTransformed(projectMap[logs[i].entityId].items, logs[i])
            }
            break;
          case "ProjectControlItem":
            if (logs[i].parentEntityId && projectMap[logs[i].parentEntityId]) {
              projectMap[logs[i].parentEntityId] = projectMap[logs[i].parentEntityId] || {
                name: 'Project ' + projectMap[logs[i].parentEntityId].name,
                items: []
              };
              this.addTransformed(projectMap[logs[i].parentEntityId].items, logs[i])
            }
            break;
          case "User":
            this.addTransformed(users, logs[i])
            break;
          case "ControlItem":
            this.addTransformed(controlItems, logs[i])
            break;
          case "ActionPlan":
            this.addTransformed(actionPlans, logs[i])
            break;
          case "ClientITProfile":
          case "NetworkDescriptionAndDiagram":
          case "SystemRolePrivilege":
          case "SystemInterconnection":
            this.addTransformed(itprofiles, logs[i])
            break;
          default: {
            this.addTransformed(others, logs[i]);
          }
        }
      } catch (e) {
        console.log(e);
      }
    }

    this.data = [...users, ...Object.values(projectMap).flatMap(a => (<any>a).items), ...controlItems, ...actionPlans, ...others, ...itprofiles];
  }

  addTransformed(list, log) {
    for (let i = 0; i < log.logDetails.length; i++) {
      list.push({
        typeOfChange: this.getTypeOfChange(log, log.logDetails[i]),
        typeOfChangeNum: this.typesOfChange[this.getTypeOfChange(log, log.logDetails[i])],
        entityName: log.entityName,
        fieldName: log.logDetails[i].fieldTitle,
        userName: log.userName,
        date: log.date,
        valueBefore: log.logDetails[i].valueBefore,
        valueAfter: log.logDetails[i].valueAfter,
      });
    }
  }

  typesOfChange = {
    'Project Control Item Updates': 0,
    'Project Control Item Added': 1,
    'Evidence': 2,
    'Status & Ownership': 3,
    'Collaborate': 4,
    'Action Plan': 5,
    'Assessment Information': 6,
    'Area Specific': 7
  }

  getTypeOfChange(log, logDetails) {
    const action = " " + (log.state == 16 ? 'Updates' : log.state == 8 ? 'Deletes' : 'Added');
    if (log.entityType == "ProjectControlItem") {
      return ['ControlType_', 'LastModifiedDate', 'DueDate', 'RevisedTargetDate', 'Instructions', 'SupplementalGuidance', 'Control', 'CustomDescription'].indexOf(logDetails.fieldName) >= 0 ? 'Project Control Item' + action :
        ['EvidenceOwnerId', 'EvidenceFrequency'].indexOf(logDetails.fieldName) >= 0 ? 'Evidence' :
          ['AssignedClientId', 'AssignedConsultantIdList', 'ControlOwner_', 'SolutionDescription', 'CopyCompanyPolicyToICA', 'ImplementationStatus', 'Rationale', 'CompletedDates', 'Completed', 'ReviewedByConsultantDates', 'ReviewedByConsultant'].indexOf(logDetails.fieldName) >= 0 ? 'Status & Ownership' :
            ['ConsultantInstructions', 'ClientInstructions', 'ConsultantNotes', 'ClientNotes', 'RelatedControls', "Dependencies", 'SourceProjectControlItem', 'RelatedProjectControlItems'].indexOf(logDetails.fieldName) >= 0 ? 'Collaborate' :
              ['WeaknessDescription', 'HowIdentified', 'ResponsibleParty', 'IdentificationDate', 'ScheduledCompletionDate', 'ActualCompletionDate', 'CurrentStatus', 'RemediationPlansActionsMilestones', 'ChangesToRemediationPlansActionsMilestones', 'Comments'].indexOf(logDetails.fieldName) >= 0 ? 'Action Plan' :
                ['AssessmentMethod_', 'AssessmentArtifacts_', 'AssessmentResults_', 'AssessorInitials_', 'AssessmentFinding_'].indexOf(logDetails.fieldName) >= 0 ? 'Assessment Information' :
                  ['RiskWeight', 'ApplicableToSystem_', 'ControlImplementation_RationalforControlScoping_', 'Risk_', 'RiskAssessorName', 'TestedInFY16_', 'TestedInFY17_', 'TestedInFY18_', 'TestedInFY19_', 'ControlWeaknesses_', 'SuggestedMitigation_', 'CVSSScore_', 'SANSCSCCrossRef_', 'RiskStatement_', 'Threat_', 'ImpactConfidentiality_', 'ImpactIntegrity_', 'ImpactAvailability_', 'Likelihood_', 'Impact_', 'RiskScore_', 'FP199Low', 'FP199Moderate', 'Priority', 'FP199High', 'FedRAMPLow', 'FedRAMPModerate', 'FedRAMPContinuousMonitoringTemplate', 'FedRAMPAnnualAssessmentGuidance', 'OrganizationalParameters', 'PrivacyAct', 'HIPAA', 'OMB_EO_HSPD', 'FISCAM', 'NISTIR7966', 'Draft800_171Rev1', 'FedRAMP', 'References', 'ISO27001', 'AssessmentObjective', 'PotentialAssessmentMethodsandObjects', 'FedRAMPRiskExposure'].indexOf(logDetails.fieldName) >= 0 ? 'Area Specific' : 'Project Control Item' + action;
    } else {
      return log.entityType.replace(/([A-Z])/g, " $1") + action;
    }
  }

  getFullName(user: User): string {
    return StringsHelper.getFullName(user);
  }

}
